import { gConsts } from '@/globals/gConsts';
import { mapGetters } from 'vuex';
import axios from 'axios';

export const apiMixin = {
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters([
            'GET_initParamsToken',
        ]),
    },
    methods: {

        /**
         * Request the API
         * @param {string} action - The action to request
         * @param {Object} request - The request object
         * @returns {Promise<Object>} The response data
         * @throws {Error} If the request fails
         */
        async requestApi(action, data = {}) {
            try {

                const body = {
                    'action': action,
                    ...data,
                }
                const response = await axios.post(gConsts.setup.io.radiobot.backend.url.dev, body, {
                    headers: {
                        'Authorization': this.GET_initParamsToken
                    }
                });
                if (response.data?.status != 200) {
                    throw response
                }
    
                return response.data;
            } catch (error) {
                throw new Error(error?.data?.msg || error?.data?.message);
            }
        },
    }
}